import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch, GlobalStore } from '../../reduxStore';
import ApiServiceFactory from '../../services/api/ApiServiceFactory';
import { translateService } from '../../services/TranslateService';
import LoginView from './LoginView';
import ApiService from '../../services/api/ApiService';
import { User } from '../../interfaces/User';
import { ResponseModalStruct } from '../../interfaces/ModalStructs';
import ResponseModal from '../ResponseModal/ResponseModal';
import moment from 'moment';
import {checkBirthdateFromLogin} from"../../hooks/useCustomerHooks";
// import { withGoogleReCaptcha, IWithGoogleReCaptchaProps } from 'react-google-recaptcha-v3'; // TODO: re-enable when BE reCaptcha is ready

interface LoginContainerState {
  step: number;
  phoneNumber: string;
  apiMessage: string;
  responseModal: ResponseModalStruct | undefined;
  fetchedToken: string | undefined;
  fetchedJwt: string | undefined;
  redirect: string;
  keepState: boolean;
}

interface StateFromProps {
  token: string;
  jwt: string;
  API_URL: string;
  WALLEY_API_URL: string;
  API_VERSION: string;
  language: string;
  setRedirect: Function;
  closeModal?: () => void;
  setUser: Function;
  customerInfoOpen: boolean;
  setIsLoggedIn: Function
  clearUserSelections: Function;
  sendGa4Event: Function;
  appContext: string;
  rootUrl: string;
  loginFromHeader?: boolean;
  changeOpenLoginFromHeader?: Function;
}

interface DispatchFromProps {
  // Redux dispatch options referenced as props
  onSetToken: (tokenObject: { token: string; jwt: string; driverLogin: boolean }) => void;
  onClearUserSelections: () => void;
  onSetApi: (apiService: any) => void;
}

class LoginContainer extends React.Component<DispatchFromProps & StateFromProps, LoginContainerState> { // TODO: re-add IWithGoogleReCaptchaProps when BE reCaptcha is ready
  api: ApiService;

  constructor(props: any) {
    super(props);
    this.state = {
      step: 0,
      phoneNumber: localStorage.getItem('C2-PN') || '',
      apiMessage: '',
      responseModal: undefined,
      fetchedToken: undefined,
      fetchedJwt: undefined,
      redirect: '',
      keepState: true
    };
    this.api = ApiServiceFactory(this.props.token, this.props.jwt, this.props.API_VERSION, this.props.API_URL, this.props.appContext, undefined, true, this.props.WALLEY_API_URL);
  }

  componentWillMount() {
    if (this.state.phoneNumber !== '') {
      this.setState({ step: 1 });
    }
  }

  componentDidMount() {
    window.history.pushState(null, '', window.location.href);
    window.onpopstate = (event: any) => {
      window.history.go(1);
    };

    const closeButton = document.querySelector('.modal-close');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        this.onReset();
        if(this.props.loginFromHeader && this.props.changeOpenLoginFromHeader) {
          // reset loginFromHeader state for correct modal text to be shown
          this.props.changeOpenLoginFromHeader();
        }
        // @ts-ignore
        this!.props!.closeModal(); // Call closeModal function
      });
    }
  }

  onNumberSubmit = async (phoneNumber: string) => {
    localStorage.setItem('C2-PN', phoneNumber);
    this.setState({
      phoneNumber,
      apiMessage: translateService.translate('loginScreen.generatingPin'),
    });
    // TODO: re-enable reCaptcha when BE is ready
    // let reCaptchaToken: string | undefined;
    // const { executeRecaptcha } = this.props.googleReCaptchaProps ?? {};
    // if (executeRecaptcha) {
    //   reCaptchaToken = await executeRecaptcha('login_request_pin');
    // }
    this.api.login
        .getPIN(phoneNumber)
        .then((res: any) => {
          if (this.props.customerInfoOpen) {
            // only reset if on customer info page
            sessionStorage.setItem('resetCustomerData', 'true');
          }
          this.setState({
            apiMessage: '',
            step: 1,
          });
          if (this.props.appContext !== 'production') {
            alert('PIN: ' + res.pin);
          }
        })
        .catch((res: any) => {
          if (res.includes('CUSTOMER_NOT_FOUND_ERROR')) {
            // log the attempted phone number

            // act as though the submission worked
            //  this.setState({
            //   step: 1,
            // });
            this.setState({
              responseModal: {
                // open: true,
                justify: 'left',
                text: translateService.translate('loginScreen.invalidCredentialsError'),
                buttonText: translateService.translate('loginScreen.buttonOk'),
              },
            });
          } else
          if (res.includes('TWO_FACTOR_AUTHENTICATION_PIN_UNSENDABLE_ERROR')) {
            this.setState({
              responseModal: {
                // open: true,
                justify: 'left',
                text: translateService.translate('loginScreen.pinRequestFailed'),
                buttonText: translateService.translate('loginScreen.buttonOk'),
              },
            });
          } else {
            this.setState({
              responseModal: {
                // open: true,
                justify: 'left',
                text: translateService.translate('loginScreen.pinRequestFailed'),
                buttonText: translateService.translate('loginScreen.buttonOk'),
              },
            });
          }
          this.setState({
            apiMessage: '',
            responseModal: {
              // open: true,
              text: translateService.translate('loginScreen.invalidCredentialsError'),
              buttonText: translateService.translate('loginScreen.buttonOk')
            }
          });
          if (this.props.appContext !== 'production') {
            alert(JSON.stringify(res));
          }
        });
  };

  onPINSubmit = (pin: string, phoneNumber: string) => {
    this.setState({
      apiMessage: translateService.translate('loginScreen.loggingIn'),
    });
    this.api.login
        .tryPIN(pin, phoneNumber)
        .then((res: any) => {
          if (this.props.appContext !== 'production') {
            // PIN alert shown on first request only
          }
          localStorage.removeItem('C2-PN');
          localStorage.setItem('loginTime', moment().format());
          if (!res.jwt) {
            res.jwt = 'notimplemented'
          }
          const hasSavedCard = !!(res.walleySavedCard || res.savedCard);

          this.api.user.fetchUser(res.token, res.jwt).then((user: User) => {
            this.setState({
              apiMessage: '',
              fetchedToken: res.token,
              fetchedJwt: res.jwt,
            });

            const savedCardFields = hasSavedCard ? {
              savedCard: true,
              lastFourDigits: res.walleyLastFourDigits || res.lastFourDigits || '',
              cardType: res.walleyCardType || res.cardType || '',
            } : {};

            if (checkBirthdateFromLogin(user.birthDate)) { // if birthdate exist + valid format, else ask user to add again like new customer
              this.props.setUser({...user, ...savedCardFields, saveToCustomer: true, smsLogin: true});
              this.props.setIsLoggedIn(true);
            } else {
              // birthdate not valid, then make undefined and ask for new birthdate/ssn
              this.props.setUser({...user, ...savedCardFields, saveToCustomer: true, birthDate: undefined, smsLogin: false});
              this.props.setIsLoggedIn(false);
            }

            if ((window as any).ap3c && user.email){
              // add customer when we know the email and if ap3c func exists
              console.log('Ortto Tracking on');
              (window as any).ap3c.track({"v":0 ,"email": user.email});
            }

            this.props.onSetToken({ token: res.token, jwt: res.jwt, driverLogin: false });
            this.props.setRedirect();
            this.props.sendGa4Event("login", { login_method: "SMS", login_result: "success"});
          }).catch(e => {
            this.props.onSetToken({ token: res.token, jwt: res.jwt, driverLogin: true });
            this.setState({
              apiMessage: '',
              fetchedToken: res.token,
              fetchedJwt: res.jwt
            });
          });

          if (!this.state.keepState) {
            this.props.clearUserSelections();
            this.props.onClearUserSelections();
          }
          else {
            const apiService = ApiServiceFactory(
                res.token || "",
                res.jwt || "",
                this.props.API_VERSION,
                this.props.API_URL,
                this.props.appContext || "",
                undefined,
                false,
                this.props.WALLEY_API_URL,
            );
            this.props.onSetApi(apiService);
          }
        })
        .catch((err) => {
          localStorage.removeItem('C2-PN');

          let errMsg = 'loginScreen.unknownError';
          if (err === 'TWO_FACTOR_AUTHENTICATION_PIN_INCORRECT_ERRORZZ') {
            errMsg = 'loginScreen.invalidCredentialsError';
          }
          this.setState({
            apiMessage: '',
            responseModal: {
              justify: 'left',
              text: translateService.translate(errMsg),
              buttonText: translateService.translate('loginScreen.buttonOk'),
            },
          });
          this.props.sendGa4Event("login", { login_method: "SMS", login_result: "failure", login_error_code: "UNKNOWN" });
        });
  };

  onReset = () => {
    localStorage.removeItem('C2-PN');
    this.setState({ step: 0 });
    this.setState({ phoneNumber: '' });
  };

  render() {
    return (
        <React.Fragment>
          <ResponseModal
              response={this.state.responseModal}
              closeFunc={() => this.setState({responseModal: undefined})}
          />
          <div className={"modal-close-container"}>
            <button className={"btn modal-close"} id={"close-login-btn"} onClick={() => this.setState({responseModal: undefined})}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                <path
                    d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"/>
              </svg>
            </button>
          </div>
          <LoginView
              language={this.props.language}
              step={this.state.step}
              phoneNumber={this.state.phoneNumber}
              onNumberSubmit={this.onNumberSubmit}
              onPINSubmit={this.onPINSubmit}
              onReset={this.onReset}
              onEmailLink={() => {
                this.api.login.sendAutoLink(this.state.phoneNumber);
                this.setState({
                  responseModal: {
                    justify: 'left',
                    text: translateService.translate('loginScreen.emailLinkInfo'),
                    buttonText: translateService.translate('loginScreen.buttonOk'),
                  },
                });
              }}
              apiMessage={this.state.apiMessage}
              emailLinkVisible={false}
              rootUrl={this.props.rootUrl}
              loginFromHeader={this.props.loginFromHeader}
          />
        </React.Fragment>
    );
  }
}

const mapStateToProps = (state: GlobalStore) => {
  // authToken becomes the prop on this container, for redux state's dbToken property
  return {
    API_URL: state.chauffeurReducer.API_URL,
    WALLEY_API_URL: state.chauffeurReducer.WALLEY_API_URL,
    API_VERSION: state.chauffeurReducer.API_VERSION,
    token: state.chauffeurReducer.dbToken,
    jwt: state.chauffeurReducer.jwt,
    language: state.chauffeurReducer.deviceLanguage,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchFromProps => {
  return {
    onSetToken: (tokenObject: { token: string; jwt: string; driverLogin: boolean }) => {
      dispatch({
        type: 'SET_TOKEN',
        payload: tokenObject,
      });
    },
    onClearUserSelections: () => {
      dispatch({
        type: 'CLEAR_SELECTIONS',
        payload: null,
      });
    },
    onSetApi: (apiService: any) => {
      dispatch({ type: 'SET_API_SERVICE', payload: apiService })
    },
  };
};

const ConnectedLoginContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginContainer);

// export default withGoogleReCaptcha(ConnectedLoginContainer) as React.ComponentType<any>; // TODO: re-enable when BE reCaptcha is ready
export default ConnectedLoginContainer as React.ComponentType<any>;
